mutation RemoveMasterTemplate($masterTemplateId: ID!) {
    removeMasterTemplate(masterTemplateId: $masterTemplateId)
}
